import { css } from 'styled-components';

export const APP_FONT_FAMILY = "'Open Sans', sans-serif";

export const checkeredBackground = css`
  // should be an even number otherwise you see a hairline split between the gradients
  --checkerboard-width: 10px;
  --checkerboard-color: #ccc;

  background-color: white;
  background-image:
    linear-gradient(45deg, var(--checkerboard-color) 25%, transparent 25%),
    linear-gradient(135deg, var(--checkerboard-color) 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, var(--checkerboard-color) 75%),
    linear-gradient(135deg, transparent 75%, var(--checkerboard-color) 75%);
  background-size: var(--checkerboard-width) var(--checkerboard-width);
  background-position:
    0 0,
    calc(var(--checkerboard-width) / 2) 0,
    calc(var(--checkerboard-width) / 2) calc(var(--checkerboard-width) / -2),
    0px calc(var(--checkerboard-width) / 2);
`;
